import {useEffect, useState} from "react";
import useUserId from "./useUserId";
import {useGetProfileByIdQuery} from "../../redux/profileApiV3";
import {skipToken} from "@reduxjs/toolkit/dist/query/react";

export function useCurrentJourneys() {
    const [currentJourneys, setCurrentJourneys] = useState([]);
    const [isReady, setIsReady] = useState(false);
    const [userId] = useUserId();

    const { data: userProfile, isSuccess, isUninitialized } = useGetProfileByIdQuery(userId ?? skipToken);

    useEffect(() => {
        if (isSuccess && !isUninitialized) {
            setCurrentJourneys([...userProfile.currentJourneys]);
            setIsReady(true);
        }
    }, [userProfile, isSuccess, isUninitialized]);

    return [currentJourneys, isReady];
}